import { useParams, useNavigate } from 'react-router'
import { useQuery } from '@tanstack/react-query'
import { api } from '../../lib/api.js'
import { Status, Spinner, Empty, relTime } from '../../components/ui.jsx'
import { useAyuda } from '../../lib/ayuda.jsx'
import { AyudaDespliegue } from '../../components/AyudaContrato.jsx'

export function Deployments() {
  // La parte del contrato que toca a esta página, en el panel de ayuda («?» de la cabecera).
  useAyuda(() => ({ titulo: 'Despliegues · el contrato', nodo: <AyudaDespliegue /> }), [])

  const { slug } = useParams()
  const navigate = useNavigate()
  const q = useQuery({
    queryKey: ['deployments', slug],
    queryFn: () => api.deployments(slug),
    refetchInterval: (r) => (r.state.data?.some((d) => d.status === 'running') ? 3000 : 20_000),
  })

  const dur = (d) => {
    if (!d.startedAt || !d.finishedAt) return '—'
    const s = Math.round((new Date(d.finishedAt) - new Date(d.startedAt)) / 1000)
    return s < 60 ? `${s}s` : `${Math.floor(s / 60)}m ${s % 60}s`
  }

  return (
    <>
      <h1 className="h1">Despliegues</h1>
      <p className="lede">Historial de builds de este proyecto.</p>

      {q.isPending && <Spinner />}
      {q.data?.length === 0 && <Empty title="Sin despliegues">Todavía no se ha desplegado nada.</Empty>}

      {q.data?.length > 0 && (
        <div className="card">
          <div className="table-scroll">
            <table className="t">
              <thead>
                <tr><th>Estado</th><th>Descripción</th><th>Duración</th><th>Cuándo</th><th></th></tr>
              </thead>
              <tbody>
                {q.data.map((d) => (
                  <tr key={d.deploymentId} className="link"
                      onClick={() => navigate(`/p/${slug}/b/${d.deploymentId}`)}>
                    <td><Status status={d.status} /></td>
                    <td className="ellipsis">{d.title || 'Despliegue'}</td>
                    <td className="mono" style={{ color: 'var(--fg-2)' }}>{dur(d)}</td>
                    <td style={{ color: 'var(--fg-2)' }}>{relTime(d.startedAt ?? d.createdAt)}</td>
                    <td style={{ textAlign: 'right', color: 'var(--fg-3)' }}>→</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}
    </>
  )
}
